<template>
  <div class="sidebar-logo-container" :class="{ collapse: collapse }">
    <transition name="sidebarLogoFade">
      <router-link
        v-if="collapse"
        key="collapse"
        class="sidebar-logo-link"
        to="/"
      >
        <img v-if="logo" :src="logo" class="sidebar-logo" />
        <h1 v-else class="sidebar-title">{{ title }}</h1>
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/">
        <img v-if="logo" :src="logo" class="sidebar-logo" />
        <h1 class="sidebar-title">{{ title }}</h1>
      </router-link>
    </transition>
  </div>
</template>

<script>
  import { ROLES_ADMIN, ROLES_TENANT, getPlateForm } from '@/utils/auth';
  import { baseCDNUrl } from '@/utils/data-update';

  export default {
    name: 'SidebarLogo',
    props: {
      collapse: {
        type: Boolean,
        required: true
      }
    },
    data() {
      return {
        title: '医推摩盘',
        logo: '',
        width: '',
        height: 32
      };
    },
    methods: {
      getLogoWidth(url) {
        const img = new Image();
        img.src = url;
        img.onload = () => {
          this.width = (this.height * img.width) / img.height;
        };
      },
      setTitleLogo() {
        const link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        link.href = this.logo;
        document.getElementsByTagName('head')[0].appendChild(link);
      }
    },
    created() {
      this.title = localFun.get('enterpriseName');
      if (getPlateForm() === ROLES_ADMIN) {
        this.logo = baseCDNUrl + 'logo.png';
      } else if (getPlateForm() === ROLES_TENANT) {
        if (
          localFun.get('enterpriseLogo') == 'null' ||
          localFun.get('enterpriseLogo') == 'undefined'
        )
          this.logo = '';
        else this.logo = localFun.get('enterpriseLogo');
      }
      if (!this.logo) {
        const link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement('link');
        link.type && link.parentNode.removeChild(link);
        this.logo = baseCDNUrl + 'this_is_a_fake_picture.png?v=1'; // 这个图片是个假的，制造404的效果, v=1是为了更新图片的时候不被缓存
      }
      this.getLogoWidth(this.logo);
      this.setTitleLogo();
      if (this.logo.includes('this_is_a_fake_picture.png')) {
        // 重置
        this.logo = '';
      }
    }
  };
</script>

<style lang="scss" scoped>
  .sidebarLogoFade-enter-active {
    transition: opacity 1.5s;
  }

  .sidebarLogoFade-enter,
  .sidebarLogoFade-leave-to {
    opacity: 0;
  }

  .sidebar-logo-container {
    position: relative;
    z-index: 1;
    width: 100%;
    min-height: 50px;
    text-align: center;
    overflow: hidden;
    padding: 5px 16px 5px 24px;
    box-sizing: border-box;
    background: #fff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
    border-right: 2px solid #f5f5f5;

    & .sidebar-logo-link {
      display: flex;
      height: 40px;
      align-items: center;
      justify-content: flex-start;

      & .sidebar-logo {
        margin-right: 10px;
        width: 40px;
        height: 40px;
      }

      & .sidebar-title {
        margin: 0;
        font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
        text-align: left;
        font-size: 14px;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }

    &.collapse {
      padding: 5px 0;
      display: flex;
      justify-content: center;
      .sidebar-logo {
        margin-right: 0px;
        width: 40px;
        height: 40px;
      }
    }
  }
</style>
